import { memo } from 'react';
import type { NodeTypes } from '@xyflow/react';
import { AircraftNode } from './AircraftNode';
import { DocumentNode } from './DocumentNode';
import { EngineNode } from './EngineNode';
import { EventNode } from './EventNode';
import { GenericNode } from './GenericNode';
import { GroupNode } from './GroupNode';
import { PartNode } from './PartNode';
import { ProjectNode } from './ProjectNode';
import { ReferenceNode } from './ReferenceNode';
import { sameCardProps } from './sameCardProps';

/**
 * Keyed by `flowType` in useGraphLayout: the group kind is `drillGroup`, unknown kinds are `generic`; an IPC position
 * draws the generic card too. Each card is memoised, so a frame of a node move redraws only the positions, not the
 * cards.
 */
export const nodeTypes: NodeTypes = {
  engine: memo(EngineNode, sameCardProps),
  aircraft: memo(AircraftNode, sameCardProps),
  part: memo(PartNode, sameCardProps),
  reference: memo(ReferenceNode, sameCardProps),
  document: memo(DocumentNode, sameCardProps),
  event: memo(EventNode, sameCardProps),
  drillGroup: memo(GroupNode, sameCardProps),
  project: memo(ProjectNode, sameCardProps),
  ipc: memo(GenericNode, sameCardProps),
  generic: memo(GenericNode, sameCardProps),
};
